import React from "react";

// reactstrap components
import { Row, Col, Container } from "reactstrap";

// core components

function HomePageHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        if(pageHeader.current){
          pageHeader.current.style.transform =
            "translate3d(0," + windowScrollTop + "px,0)";
        }
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });
  return (
    <>
      <div className="page-header page-header-very-small">
      <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/liquid_love_header.jpeg") + ")",
            maxWidth: "100%",
          }}
          ref={pageHeader}
        ></div>
        
        <div className="content-center">        
          <Container>
          <Row className="align-items-center">
            <Col md="2">
            </Col>
            <Col md="8">          
              <div style={{color: "white"}}>
                <h4>Sri Sathya Sai Seva Organisations</h4>
                <h5>Liquid Love</h5>
              </div>          
             </Col>
             <Col md="2">
            </Col>
             </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default HomePageHeader;